export default __webpack_public_path__ + "static/media/t1.7a599542.jpg";